require('./insuranceRequestWizardRequestError.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ utilities
const { formatText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError');

// @ constants
const ROUTES = require('../../../insuranceConstants/insuranceRequestRoutes');
const { THIRD_STEP, FOURTH_STEP } = require('constants/index');

class InsuranceRequestWizardRequestError extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const mySecondaryButton = document.querySelector('.insurance-request-wizard-request-error .wizard-error-step__secondary-button button');

        if (mySecondaryButton) {
            mySecondaryButton.addEventListener('click', this.handleMySecondaryButtonOnClick);
        }

    }

    componentWillUnmount() {
        const { isRelated, setData, isRnc } = this.props;

        if (isRelated || isRnc) {
            setData(THIRD_STEP, {
                errorDetails: '',
                errorQuotation: '',
                error: '',
                linkingError: ''
            });
        }

        if (isRelated) {
            setData(FOURTH_STEP, {
                errorPayment: '',
            });
        }

        const mySecondaryButton = document.querySelector('.insurance-request-wizard-request-error .wizard-error-step__secondary-button button');

        if (mySecondaryButton) {
            mySecondaryButton.removeEventListener('click', this.handleMySecondaryButtonOnClick);
        }
    }

    handleMySecondaryButtonOnClick() {
        window.location.reload();
    }

    render() {
        const {
            title,
            text,
            buttonLabel,
            buttonLink,
            secondaryButtonLabel,
            secondaryButtonLink,
            notifyWrapUp
        } = this.props;

        const finalTitle = !!title ? title : formatText('insuranceRequestError-title');
        const finalText = !!text ? text : formatText('insuranceRequestError-message');
        const finalButtonLabel = !!buttonLabel ? buttonLabel : formatText('insuranceRequestError-backButton');

        const returnMainButton = {
            label: finalButtonLabel,
            url: buttonLink
        };

        const secondaryButton = {
            label: secondaryButtonLabel,
            url: secondaryButtonLink
        }

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardError
                        notifyWrapUp={notifyWrapUp}
                        errorMessage={finalTitle}
                        mainButton={returnMainButton}
                        secondaryButton={secondaryButton}
                        customClassName={'insurance-request-wizard-request-error'}
                    >
                        <span>{finalText}</span>
                    </WizardError>
                </div>
            </div>
        );
    }
}

InsuranceRequestWizardRequestError.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonLink: PropTypes.string,
    secondaryButtonLabel: PropTypes.string,
    secondaryButtonLink: PropTypes.string,
    setData: PropTypes.func,
    isRelated: PropTypes.bool,
    isRnc: PropTypes.bool,
    notifyWrapUp: PropTypes.bool,
};

InsuranceRequestWizardRequestError.defaultProps = {
    buttonLink: ROUTES.INSURANCES_LANDING,
    secondaryButtonLabel: '',
    secondaryButtonLink: '',
    setData: () => { },
    isRnc: false,
    notifyWrapUp: true,
};

module.exports = InsuranceRequestWizardRequestError;
